import React from 'react';
import commonStyles from './CommonStyles.module.css'; // Kita akan buat file CSS ini

function InputField({
    id,
    label,
    name,
    type = 'text', // default type adalah text
    value,
    onChange,
    onBlur, // Tambahan handler untuk validasi saat field kehilangan fokus
    error,
    required = false,
    placeholder = '',
    disabled = false,
    readOnly = false,
    autoComplete = 'on',
    helperText = '', // Text bantuan di bawah input
    iconLeft = null, // Ikon pada sisi kiri input
    iconRight = null, // Ikon pada sisi kanan input
    className = '', // class tambahan untuk container
    inputClassName = '', // class tambahan untuk input
    maxLength,
    minLength,
    min,
    max,
    step,
    pattern,
    textarea = false, // prop untuk menentukan apakah ini textarea
    rows = 3, // jumlah baris untuk textarea
    select = false, // prop untuk menentukan apakah ini select
    options = [], // array of { value: 'val', label: 'Label' } untuk select
    multiple = false, // untuk select multiple
    size, // ukuran untuk select
    children, // untuk menambahkan custom element
    ...props // untuk atribut tambahan lainnya
}) {
    const inputId = id || name; // Gunakan id jika ada, jika tidak gunakan name
    
    // Handle onChange dengan modifikasi tambahan jika diperlukan
    const handleChange = (e) => {
        if (type === 'file') {
            // Untuk file uploads - bisa menambahkan logika tambahan disini
            onChange && onChange(e);
        } else {
            onChange && onChange(e);
        }
    };

    return (
        <div className={`${commonStyles.formGroup} ${className}`}>
            {label && (
                <label htmlFor={inputId} className={commonStyles.label}>
                    {label}
                    {required && <span className={commonStyles.requiredIndicator}> *</span>}
                </label>
            )}
            
            <div className={`${commonStyles.inputWrapper} ${iconLeft || iconRight ? commonStyles.hasIcon : ''}`}>
                {iconLeft && <span className={commonStyles.iconLeft}>{iconLeft}</span>}
                
                {textarea ? (
                    <textarea
                        id={inputId}
                        name={name}
                        value={value || ''}
                        onChange={handleChange}
                        onBlur={onBlur}
                        required={required}
                        disabled={disabled}
                        readOnly={readOnly}
                        placeholder={placeholder}
                        rows={rows}
                        className={`${commonStyles.input} ${commonStyles.textarea} ${error ? commonStyles.inputError : ''} ${inputClassName}`}
                        maxLength={maxLength}
                        minLength={minLength}
                        {...props}
                    />
                ) : select ? (
                    <select
                        id={inputId}
                        name={name}
                        value={value || ''}
                        onChange={handleChange}
                        onBlur={onBlur}
                        required={required}
                        disabled={disabled}
                        multiple={multiple}
                        size={size}
                        className={`${commonStyles.input} ${commonStyles.select} ${error ? commonStyles.inputError : ''} ${inputClassName}`}
                        {...props}
                    >
                        {placeholder && <option value="">{placeholder}</option>}
                        {options.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                        {children}
                    </select>
                ) : (
                    <input
                        type={type}
                        id={inputId}
                        name={name}
                        value={type !== 'file' ? (value || '') : undefined}
                        onChange={handleChange}
                        onBlur={onBlur}
                        required={required}
                        disabled={disabled}
                        readOnly={readOnly}
                        placeholder={placeholder}
                        autoComplete={autoComplete}
                        className={`${commonStyles.input} ${error ? commonStyles.inputError : ''} ${inputClassName}`}
                        maxLength={maxLength}
                        minLength={minLength}
                        min={min}
                        max={max}
                        step={step}
                        pattern={pattern}
                        {...props}
                    />
                )}
                
                {iconRight && <span className={commonStyles.iconRight}>{iconRight}</span>}
            </div>
            
            {error && <p className={commonStyles.errorMessageInline}>{error}</p>}
            {helperText && !error && <p className={commonStyles.helperText}>{helperText}</p>}
            
            {children && !select && (
                <div className={commonStyles.childrenContainer}>
                    {children}
                </div>
            )}
        </div>
    );
}

export default InputField;